import { BRAND, FOOTER } from "@/data/content";
import { scrollToSection } from "@/lib/scroll";

export const SiteFooter = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-border/70 bg-ink py-16 lg:py-20"
  >
    <div className="shell">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <img
            src={BRAND.wordmark}
            alt="Montaire Group"
            className="h-7 w-auto"
            width="900"
            height="170"
            loading="lazy"
          />
          <p className="display mt-8 text-sm leading-tight tracking-[0.06em] text-mist">
            {FOOTER.tagline.map((line) => (
              <span key={line} className="block">
                {line}
              </span>
            ))}
          </p>
        </div>

        <div className="lg:col-span-4">
          <span className="label-mono text-mist/70">Navigation</span>
          <ul className="mt-6 space-y-3">
            {FOOTER.links.map(({ label, target }) => (
              <li key={target}>
                <button
                  type="button"
                  onClick={() => scrollToSection(target)}
                  data-testid={`footer-link-${target}`}
                  className="text-sm text-mist transition-colors duration-300 hover:text-offwhite"
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <span className="label-mono text-mist/70">Company</span>
          <p className="mt-6 text-sm font-medium uppercase tracking-[0.12em] text-offwhite">
            {FOOTER.company}
          </p>
          <p className="mt-2 text-sm text-mist">{FOOTER.location}</p>
        </div>
      </div>

      <div className="hairline mt-14" />
      <p className="label-mono mt-6 text-mist/70" data-testid="footer-copyright">
        © {new Date().getFullYear()} {FOOTER.company}. All rights reserved.
      </p>
    </div>
  </footer>
);
